import { render, staticRenderFns } from "./NsProduct.vue?vue&type=template&id=9c693410"
import script from "./NsProduct.vue?vue&type=script&lang=js"
export * from "./NsProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports